export default __webpack_public_path__ + "static/media/RCHIDash.3c2bbe70.jpeg";